/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'

const APIPagecrumb: Array<PageLink> = [
  {
    title: 'Home',
    path: '/api',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const APIPage: FC = () => (
  <>
    <div className='card p-5'>
      <h1>API Page</h1>
    </div>
  </>
)

const APIWrapper: FC = () => {
  return (
    <>
      <APIPage />
    </>
  )
}

export {APIWrapper}
